import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M15 11V4H4v8.17L5.17 11H6z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 13c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10zm-12-.83V4h11v7H5.17L4 12.17zM22 7c0-.55-.45-1-1-1h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7z"
})), 'ForumTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ForumTwoTone.js
// module id = 3918
// module chunks = 2